module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"dialogHeader":"Хотите отправить сообщение кандидату?"}}')
  delete Component.options._Ctor
}
